import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_branch_default_pricing_scheme_hdr_RowClass } from '../../dbschema/bl_fi_mst_branch_default_pricing_scheme_hdr.model';

export class BranchDefaultPricingSchemeHdrContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_default_pricing_scheme_hdr: bl_fi_mst_branch_default_pricing_scheme_hdr_RowClass = new bl_fi_mst_branch_default_pricing_scheme_hdr_RowClass();
}